var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[(_vm.textState === 1 && _vm.textShow)?_c('div',[_vm._v(" 距离团购结束还剩 ")]):_vm._e(),(_vm.type === 2 && _vm.textShow)?_c('div',[_vm._v("剩余")]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }